(() => {
  const panel = document.querySelector('[data-cs-quote]');
  if (!panel || panel.dataset.initialized) return;
  panel.dataset.initialized = 'true';
  if ('IntersectionObserver' in window) {
    const visibility = new IntersectionObserver(entries => {
      document.documentElement.classList.toggle('cs-quote-in-view', entries.some(entry => entry.isIntersecting));
    });
    visibility.observe(panel);
  }
  const products = JSON.parse(panel.querySelector('[data-quote-products]').textContent);
  let pending = null;
  let published = false;
  let shadowObserver;
  let tries = 0;
  const publish = () => {
    if (!pending || published || !window.Shopify?.analytics?.publish) return;
    Shopify.analytics.publish('quote_request_submitted', {
      product_handle: pending.product_handle,
      quantity: pending.quantity,
      currency: 'USD'
    });
    published = true;
    panel.dataset.quoteEvent = 'published';
    console.info('quote_request_submitted', { product_handle: pending.product_handle, quantity: pending.quantity, currency: 'USD' });
  };
  const connect = () => {
    const host = panel.querySelector('shopify-forms-embed');
    const root = host?.shadowRoot;
    const form = root?.querySelector('form');
    const product = root?.getElementById('custom#product');
    const quantity = root?.getElementById('custom#quantity');
    if (!form || !product || !quantity) return false;
    const setValue = (input, value) => {
      Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set.call(input, value);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };
    if (panel.dataset.productHandle) {
      setValue(product, panel.dataset.productTitle);
      product.readOnly = true;
    } else {
      const options = document.createElement('datalist');
      options.id = 'cs-quote-product-options';
      products.forEach(item => { const option = document.createElement('option'); option.value = item.title; options.append(option); });
      root.append(options);
      product.setAttribute('list', options.id);
      product.setAttribute('placeholder', 'Choose or type a product');
    }
    quantity.min = '1';
    quantity.step = '1';
    const style = document.createElement('style');
    style.textContent = 'input,select,textarea,button{font-size:16px!important}form{max-width:600px!important;margin-inline:auto!important}';
    root.append(style);
    const trap = document.createElement('div');
    trap.style.cssText = 'position:absolute;left:-10000px;width:1px;height:1px;overflow:hidden';
    trap.setAttribute('aria-hidden', 'true');
    const label = document.createElement('label');
    label.textContent = 'Leave this field blank';
    const honeypot = document.createElement('input');
    honeypot.name = 'quote_website';
    honeypot.tabIndex = -1;
    honeypot.autocomplete = 'off';
    label.append(honeypot); trap.append(label); form.append(trap);
    const remember = event => {
      if (honeypot.value) { event.preventDefault(); event.stopImmediatePropagation(); pending = null; return; }
      const value = Number(quantity.value);
      if (!Number.isInteger(value) || value < 1) {
        quantity.setCustomValidity('Enter a whole quantity of at least 1.');
        quantity.reportValidity(); event.preventDefault(); event.stopImmediatePropagation(); pending = null; return;
      }
      quantity.setCustomValidity('');
      if (product.readOnly && product.value !== panel.dataset.productTitle) setValue(product, panel.dataset.productTitle);
      pending = { product_handle: panel.dataset.productHandle || products.find(item => item.title === product.value)?.handle || '', quantity: value };
      published = false;
    };
    quantity.addEventListener('input', () => quantity.setCustomValidity(''));
    form.addEventListener('submit', remember, true);
    // Forms replaces the form with its configured success message only after server acceptance.
    const success = () => {
      const heading = [...root.querySelectorAll('h1,h2,h3,[role="heading"]')].find(el => el.textContent.trim() === 'Quote request received');
      if (heading && !root.querySelector('form')) {
        panel.dataset.quoteSubmission = 'received';
        publish();
      }
    };
    shadowObserver = new MutationObserver(success);
    shadowObserver.observe(root, { subtree: true, childList: true });
    panel.dataset.quoteReady = 'true';
    return true;
  };
  const timer = setInterval(() => {
    tries++;
    if (panel.dataset.quoteReady) {
      if (panel.dataset.quoteSubmission === 'received') publish();
    } else connect();
    if (tries >= 240 || published) clearInterval(timer);
  }, 500);
  connect();
})();
